import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import ConfirmationPage from '../../ConfirmationPage/ConfirmationPage';
import { getHasMutualFundPaperlessConfirmations } from '../../../../redux/modules/user/Paperless/paperless.selectors';
import CollegeBrandingContainer from '../../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import CollegeContributeWhatsNext from '../../WhatsNext/CollegeContribute/CollegeContributeWhatsNext';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../../redux/modules/authentication/authentication.module.selectors';

const CollegeContributeConfirmation = ({
  isIFrame,
  isSalesforceRep,
  customerWebViewEnabled,
  confirmationNumber,
  hasPaperless,
  tradeDate,
  transactions,
}) => (
  <CollegeBrandingContainer>
    <ConfirmationPage
      isIFrame={isIFrame}
      isSalesforceRep={isSalesforceRep}
      customerWebViewEnabled={customerWebViewEnabled}
      confirmationNumber={confirmationNumber}
      hasPaperless={hasPaperless}
      heroTitle="Your contribution has been submitted!"
      tradeDate={tradeDate}
      transactions={transactions}
      whatsNext={CollegeContributeWhatsNext}
    />
    <p className="container">2820024</p>
  </CollegeBrandingContainer>
);

const mapStateToProps = (state) => {
  const {
    executeCollegeContribute: { confirmationNumber, tradeDate, transactions },
  } = state;

  return {
    isIFrame: isEmbeddedInIFrame(state),
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    confirmationNumber,
    hasPaperless: getHasMutualFundPaperlessConfirmations(state),
    tradeDate,
    transactions,
  };
};

export default compose(connect(mapStateToProps))(CollegeContributeConfirmation);
